import React from 'react';
import { connect } from 'react-redux';
import { loginUser } from '../../duck';
import LoginForm from '../../components/LoginForm';

const loginRequired = (ComposedComponent) => {
  class LoginRequired extends React.Component {

    onSubmit = (email, password) => {
      this.props.dispatch(loginUser(email, password))
    };

    render() {
      const token = window.sessionStorage.accessToken;
      return (
        (!token || token === '')  ?
          <LoginForm { ...this.props } onSubmit={ this.onSubmit } /> :
          <ComposedComponent { ...this.props } />
      );
    }
  }

  return connect(state => ({
    isFetching: state.core.auth.get('isFetching', false),
    errorMsg: state.core.auth.get('errorMsg', '')
  }))(LoginRequired);
};

export default loginRequired;



// WEBPACK FOOTER //
// ./src/core/containers/loginRequired/loginRequired.js